import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const common = {
    actions: {
        cancel: 'Cancel',
        save: 'Save',
        confirm: 'Confirm',
        close: 'Close',
        back: 'Back',
        moreOptions: 'More options',
        previousMonth: 'Previous month',
        nextMonth: 'Next month',
        previousDay: 'Previous day',
        nextDay: 'Next day',
        previousYear: 'Previous year',
        nextYear: 'Next year',
    },
    relativeDate: {
        today: 'Today',
        yesterday: 'Yesterday',
    },
    periodMenu: {
        open: 'Choose period',
        current: 'Current',
    },
    picker: {
        stuckTitle: "The picker didn't open",
        stuckBody: 'Close Kontto completely (swipe it away from recents), open it again and try once more.',
        noFileAppTitle: "We couldn't open your files",
        noFileAppBody: 'Your device has no active files app to pick the document from. Enable the "Files" app in your Android settings (or install Files by Google) and try again.',
        genericTitle: "Couldn't open the picker",
        genericBody: 'Try again. If it keeps happening, close Kontto completely and open it once more.',
        fileMissingTitle: "We couldn't open that file",
        fileMissingBody: 'If it lives in iCloud, Google Drive or another cloud, open your files app and download it to the device before picking it here.',
    },
    // Receipt shared from another app that Android wouldn't let us read —
    // see lib/shareIntentError.
    shareIntent: {
        // No "Android" here: this toast also shows on iOS (REACT-NATIVE-16), where
        // blaming Android for blocking the file is simply false.
        failedTitle: "We couldn't open the receipt",
        failedBody: 'Your device did not grant Kontto access to that file. Open the app and use "Scan receipt" to import it straight from your gallery.',
        // Different case: the file opened fine — it's the type that doesn't fit.
        unsupportedTitle: "That file isn't a receipt",
        unsupportedBody: 'Kontto reads receipts as images or PDFs. For CSV or OFX statements, open the app and use More › Import & export.',
    },
    link: {
        failedTitle: "Couldn't open the link",
        failedBody: 'Your device blocked the browser from opening. You can also find the page at kontto.com.br.',
    },
    logoSelector: {
        title: 'Bank logo',
        automatic: 'Automatic',
        detectedLogo: 'Detected logo',
        noDetectedLogo: 'No logo detected',
        groups: {
            brands: 'Card networks',
            banksBr: 'Brazilian banks and wallets',
            banksUs: 'US and international banks',
            benefits: 'Meal cards and benefits',
        },
    },
} satisfies DeepPartialStrings<TranslationSchema['common']>;
